// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Categories from '../components/Categories';
import {actions as ProductActions} from '../../products/duck';
import {actions as CategoryActions} from '../../categories/duck';
import {actions as SubcategoryActions} from '../../sub-categories/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    user: state.auth.user,
    categories: state.categories.categories,
    createCategorySuccess: state.categories.createCategorySuccess,
    isFetching: state.categories.isFetching,
    isSaving: state.categories.isSaving,
    pagination: state.categories.pagination,
    sortCategoriesError: state.categories.sortCategoriesError,
    sortCategoriesSuccess: state.categories.sortCategoriesSuccess,
    editCategorySuccess: state.categories.editCategorySuccess,
    createCategoryError: state.categories.createCategoryError,
    editCategoryError: state.categories.editCategoryError,
    subcategory: state.subCategories.subcategory,
    deleteCategorySuccess: state.categories.deleteCategorySuccess,
    updateSubcategorySuccess: state.subCategories.updateSubcategorySuccess,
    createSubcategorySuccess: state.subCategories.createSubcategorySuccess,
    deleteSubcategorySuccess: state.subCategories.deleteSubcategorySuccess,
    deleteSubcategoryError: state.subCategories.deleteSubcategoryError,
    updateSubcategoryError: state.subCategories.updateSubcategoryError,
    createSubcategoryError: state.subCategories.createSubcategoryError,
    sortSubcategoryError: state.subCategories.sortSubcategoryError,
    isSavingSubcategory: state.subCategories.isSaving,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ProductActions,
        ...CategoryActions,
        ...SubcategoryActions,
      },
      dispatch
    )
)(Categories);
